import { useRef } from "react";

// Inside a Radix dialog, a combobox popup must render in the dialog: the dialog blocks
// pointer events outside its content and closes on outside clicks.
export function useComboboxPortalContainer() {
  const container = useRef<HTMLElement | null>(null);

  function attach(element: HTMLElement | null) {
    container.current =
      element?.closest<HTMLElement>('[data-slot="dialog-content"]') ??
      document.body;
  }

  return { container, attach };
}
